const crcTable = Array.from({ length: 256 }, (_, value) => {
  let crc = value
  for (let bit = 0; bit < 8; bit += 1) crc = (crc & 1) ? 0xedb88320 ^ (crc >>> 1) : crc >>> 1
  return crc >>> 0
})

function crc32(bytes) {
  let crc = 0xffffffff
  bytes.forEach(byte => { crc = crcTable[(crc ^ byte) & 0xff] ^ (crc >>> 8) })
  return (crc ^ 0xffffffff) >>> 0
}

function uint16(value) {
  return [value & 0xff, (value >>> 8) & 0xff]
}

function uint32(value) {
  return [value & 0xff, (value >>> 8) & 0xff, (value >>> 16) & 0xff, (value >>> 24) & 0xff]
}

function buildZip(files) {
  const encoder = new TextEncoder()
  const localParts = []
  const centralParts = []
  let offset = 0

  files.forEach(file => {
    const name = encoder.encode(file.name)
    const data = encoder.encode(file.content || '')
    const checksum = crc32(data)
    const localHeader = new Uint8Array([
      ...uint32(0x04034b50), ...uint16(20), ...uint16(0x0800), ...uint16(0), ...uint16(0), ...uint16(0),
      ...uint32(checksum), ...uint32(data.length), ...uint32(data.length), ...uint16(name.length), ...uint16(0),
    ])
    localParts.push(localHeader, name, data)

    const centralHeader = new Uint8Array([
      ...uint32(0x02014b50), ...uint16(20), ...uint16(20), ...uint16(0x0800), ...uint16(0), ...uint16(0), ...uint16(0),
      ...uint32(checksum), ...uint32(data.length), ...uint32(data.length), ...uint16(name.length), ...uint16(0), ...uint16(0),
      ...uint16(0), ...uint16(0), ...uint32(file.name.endsWith('/') ? 0x10 : 0), ...uint32(offset),
    ])
    centralParts.push(centralHeader, name)
    offset += localHeader.length + name.length + data.length
  })

  const centralSize = centralParts.reduce((sum, part) => sum + part.length, 0)
  const endRecord = new Uint8Array([
    ...uint32(0x06054b50), ...uint16(0), ...uint16(0), ...uint16(files.length), ...uint16(files.length),
    ...uint32(centralSize), ...uint32(offset), ...uint16(0),
  ])
  return new Blob([...localParts, ...centralParts, endRecord], { type: 'application/zip' })
}

const copyTemplate = `标题：
在这里填写作品标题

正文：
在这里填写作品正文，可以写多行

标签：（每行填写一个标签，不要加 #）
咖啡
通勤
办公室

图片顺序：（每行填写一个图片文件名）
01.jpg
02.jpg
03.jpg
`

function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = filename
  anchor.click()
  window.setTimeout(() => URL.revokeObjectURL(url), 1000)
}

export function createImageWorkPackageTemplateBlob() {
  const instructions = `图文作品素材包使用说明

1. 将作品图片放入 images 文件夹。
2. 图片建议按 01.jpg、02.jpg 的顺序命名。
3. 打开“作品文案.txt”，填写标题、正文和标签。
4. 标签和图片顺序都是一行填写一个。
5. “图片顺序”中的文件名必须和 images 文件夹内的图片一致。
6. 完成后选中“作品文案.txt”、images 文件夹和本说明文件，重新压缩为 ZIP 上传。
`
  return buildZip([
    { name: '作品文案.txt', content: copyTemplate },
    { name: 'images/', content: '' },
    { name: '使用说明.txt', content: instructions },
  ])
}

export function downloadImageWorkPackageTemplate() {
  downloadBlob(createImageWorkPackageTemplateBlob(), '图文作品素材包模板.zip')
}

export function createVideoWorkPackageTemplateBlob() {
  const videoCopyTemplate = copyTemplate.replace('图片顺序：（每行填写一个图片文件名）\n01.jpg\n02.jpg\n03.jpg', '视频文件名：\n作品视频.mp4')
  const instructions = `视频作品素材包使用说明

1. 将一个视频文件放入 video 文件夹。
2. 打开“作品文案.txt”，填写标题、正文和标签。
3. 标签一行填写一个，不要加 #。
4. “视频文件名”必须和 video 文件夹内的视频名称一致。
5. 完成后选中“作品文案.txt”、video 文件夹和本说明文件，重新压缩为 ZIP 上传。
`
  return buildZip([
    { name: '作品文案.txt', content: videoCopyTemplate },
    { name: 'video/', content: '' },
    { name: '使用说明.txt', content: instructions },
  ])
}

export function downloadVideoWorkPackageTemplate() {
  downloadBlob(createVideoWorkPackageTemplateBlob(), '视频作品素材包模板.zip')
}
